/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var Report;
(function (Report) {
    let status;
    (function (status) {
        status["OPEN"] = "OPEN";
        status["STARTED"] = "STARTED";
        status["CLOSED"] = "CLOSED";
        status["SIGNED"] = "SIGNED";
    })(status = Report.status || (Report.status = {}));
})(Report || (Report = {}));
